<section class="commission">
  <div class="commission__header">
    <div class="commission__header-top row justify-space-between align-center">
      <div class="commission__heading">
        <h2 class="commission__title" mat-dialog-title>{{ data.template.title }}</h2>
      </div>

      <div class="commission__close">
        <button type="button" class="commission__close-button btn-icon" aria-label="Fechar" (click)="closeDialogCommission()">
          <app-svg-icon
            src="assets/icons/close-icon.svg"
            width="18px"
            height="18px"
            color="lightGray"
          ></app-svg-icon>
        </button>
      </div>
    </div>

    <div class="commission__tabs-row">
      <div class="commission__tabs">
        <app-tabs-navigation
          position="left"
          height="44px"
          [currentTab]="currentTab"
          [tabs]="visibleTabs"
          [products]="productsTabs"
          [type]="TabTypeEnum.Modal"
          appearance="modern"
          (changeTabsEvent)="changeTabs($event)"
          (insertProductEvent)="insertProduct($event)"
          (deleteProductByTabEvent)="deleteProductByTab($event)"
        ></app-tabs-navigation>
      </div>
    </div>
  </div>

  <div
    class="commission__body"
    [ngSwitch]="type"
    [ngClass]="{
      'commission__body--edit': type !== Action.View,
      'commission__body--view': type === Action.View
    }"
  >
    <ng-container *ngSwitchCase="Action.View">
      <ng-container *ngFor="let product of commission.ProductsComission">
        <app-comissao-visualizacao
          class="fade-in"
          *ngIf="currentTab === product.ProductId"
          [product]="product"
          [parameters]="parameters"
        ></app-comissao-visualizacao>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <ng-container
        *ngFor="
          let product of commission.ProductsComission;
          let indexEdit = index
        "
      >
        <app-comissao-form
          class="fade-in"
          *ngIf="currentTab === product.ProductId"
          [parameters]="parameters"
          [type]="type"
          [product]="product"
          [products]="productsSelect"
          [firstProduct]="indexEdit === 0"
          [commission]="commission"
          (changesProductIdValueEvent)="changesProductValue($event)"
          (formValueEvent)="getformValue($event)"
          (changesFormValueEvent)="changesFormValue($event)"
        ></app-comissao-form>
      </ng-container>
    </ng-container>
  </div>

  <div
    class="commission__footer row align-center justify-space-around"
    [ngClass]="{
      'commission__footer--compact': type === Action.View,
      'commission__footer--actions': type !== Action.View
    }"
  >
    <ng-container *ngIf="type !== Action.View">
      <button class="commission__back ui-btn ui-btn--secondary" [mat-dialog-close]="false">Voltar</button>
      <button class="commission__save ui-btn ui-btn--primary" (click)="handlerSaveCommission()">
        <span>Salvar</span>
      </button>
    </ng-container>
  </div>
</section>
